<template>
<h4 v-if="isNoConnectionToServer">Немає св'язку з сервером</h4>

<subscriptions-table
	:isTableLoading="isTableLoading"
	:headers="tableHeader"
	:items="tableItems"
	:onSubmit="onSubmit"
	:notifacation-text="Station.settingNames[Station.passportKeys.notificationDistributionLists.self]"
/>

<pop-up-modal
	v-model:show="isSubmitResultModal"
	title="Оновлення підписок"
	:title-style="submitResultBgStyle"
	confirmButtonTitle="Ок"
	rejectButtonTitle=""
	size="modal-md"
>
	<template v-slot:body>
		{{ submitResultText }}
	</template>
</pop-up-modal>
</template>


<script>
import SubscriptionsTable from './SubscriptionsTable.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore'
import PopUpModal from '../PopUpModal.vue'
import { Station } from '@/models/station'

export default {
	inject: ['headerHeight'],

	components: {
		PopUpModal,
		SubscriptionsTable,
	},

	props: {},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			accountStore,
			stationsStore,
			Station,
		}
	},

	data() {
		return {
			//
			isNoConnectionToServer: false,
			// Table
			isTableLoading: true,
			// Submit result modal
			isSubmitResultModal: false,
			submitResultText: '',
			submitResultBgStyle: '', // bg-success-subtle or bg-danger-subtle
		}
	},

	created() {
		this.initPage()
	},

	mounted() {
		document.title = "Підписки СКЗ"
	},

	methods: {
		async initPage() {
			// Read all stations
			await this.stationsStore.readStations((result) => {
				this.isNoConnectionToServer = !result
				this.isTableLoading = !result
			})
		},

		onSubmit(values) {
			//console.log('form values', values)
			const stationId = values.stationId
			const station = this.stationsStore.station(stationId)
			
			// Iterate notification
			Station.notificationNames.forEach((key) => {
				// If notification is active in form
				if(values[key]) {
					station?.subscribeToNotification(this.userId, key)
				} else {
					station?.unsubscribeFromNotification(this.userId, key)
				}
			})

			// Add notification_distribution_lists to form values
			const payload = {}
			payload[Station.passportKeys.notificationDistributionLists.self] =
				station.passport.get(Station.passportKeys.notificationDistributionLists.self)
			//console.log('pyload', payload)

			this.stationsStore.updatePasport((result) => {
				let resultText = ''
				
				if (result) {
					resultText = `Підписки на сповіщення станції "${station.name}" успішно оновлено.`
				} else {
					console.error("Passport (notificationDistributionLists) update error")
					resultText = `Під час оновлення підписок на сповіщення станції "${station.name}" сталася помилка.`
				}

				this.setSubmitResult(resultText, result)
			}, stationId, payload)
		},

		setSubmitResult(text, sucess=true) {
			this.submitResultText = text
			this.submitResultBgStyle = sucess ? 'bg-success-subtle' : 'bg-danger-subtle'
			this.isSubmitResultModal = true
		}
	},

	computed: {
		userId() { return this.accountStore.userId },

		tableHeader() {
			const header = []
			
			header.push({ text: 'Назва', value: 'name', sortable: true })
			if (this.accountStore.isPrimary) {
				header.push({ text: 'Організація', value: Station.passportKeys.orgName, sortable: true })
			}
			header.push({ text: 'Кількість підписок', value: 'subscriptions_count' })

			return header
		},

		tableItems() {
			const tableItems = []

			// Iterate over stations, make station row
			this.stationsStore?.stationsArray.forEach(station => {
				if (!station.isActive) {
					return
				}
				//console.log("Station", station.name, station)
				let row = new Object()
				// Notification keys
				const keys = Station.passportKeys.notificationDistributionLists

				row['id'] = station.id
				row['name'] = station.shortName ? station.shortName : station.name
				row['subscriptions_count'] = 0
				row[Station.passportKeys.orgName] = station.passport.get(Station.passportKeys.orgName)
				row['layout'] = {
					columns: [
						[keys.connection, keys.potentialOutOfRange, keys.u220],
						[keys.channel_1, keys.channel_2, keys.shunt],
						[keys.securityCircuit1, keys.securityCircuit2, keys.securityCircuit3],
						[keys.securityCircuit4, keys.securityCircuit5, keys.securityCircuit6],
					],
					resultText: '',
				}
				row['form'] = { stationId: station.id }
				
				const subcriptions = station.passport.get(Station.passportKeys.notificationDistributionLists.self)
				// Iterate all alert keys
				row['layout'].columns.flat(1).forEach((alertKey) => {
					if (alertKey === Station.passportKeys.notificationDistributionLists.self) {
						return
					}
					
					// Search subscription for this user account
					const isSubscribe = subcriptions
						? subcriptions[alertKey]?.includes(this.userId)
						: false
					row['form'][alertKey] = isSubscribe

					row['subscriptions_count'] = isSubscribe ? row['subscriptions_count'] + 1 : row['subscriptions_count']
				})

				tableItems.push(row)
			})

			return tableItems
		},
	},

	beforeUnmount() {},

	unmounted() {},
}
</script>




<style scoped>
</style>
